module.exports = __webpack_public_path__ + "img/area-part3-251.76311744.png";